import React from 'react';
import { useSelector } from 'react-redux';

import { MODAL_TYPES, TOOL_BUTTON_NAMES } from 'constants/super-admin';
import { selectActiveTool } from 'selectors/super-admin';
import { FjFlexContainer } from 'components/primitives';
import { modalsSelector } from 'selectors';
import AlertUi from 'components/alert-ui';
import type { AlertStore } from 'components/alert-ui';

import LicenseConfirmationModal from './modals/license-confirmation-modal';
import LicenseDetailsModal from './modals/license-details-modal';
import InstitutionalLicense from './institutional-license';
import SuperAdminToolArea from './super-admin-tool-area';
import IndividualLicense from './individual-license';
import LicenseModal from './modals/license-modal';
import Users from './users';
import { ProductVersionTable } from './product-version';

interface SuperAdminProps {
  store: AlertStore;
}

export default ({ store }: SuperAdminProps): React.ReactElement => {
  const { modalType } = useSelector(modalsSelector) as { modalType?: string };
  const selectedTool = useSelector(selectActiveTool) as string;

  const pageMap: Record<string, React.ReactElement> = {
    [TOOL_BUTTON_NAMES.INSTITUTION_LICENSE]: <InstitutionalLicense />,
    [TOOL_BUTTON_NAMES.INDIVIDUAL_LICENSE]: <IndividualLicense />,
    [TOOL_BUTTON_NAMES.USERS]: <Users />,
    [TOOL_BUTTON_NAMES.PRODUCT_VERSION]: <ProductVersionTable />,
  };
  const currentPage = React.useMemo(() => pageMap[selectedTool], [selectedTool]);

  const modalMap: Record<string, React.ReactElement> = {
    [MODAL_TYPES.CREATE_NEW_LICENSE]: <LicenseModal />,
    [MODAL_TYPES.MANAGE_LICENSE]: <LicenseModal />,
    [MODAL_TYPES.LICENSE_DETAILS]: <LicenseDetailsModal />,
  };
  const currentModal = React.useMemo(() => modalMap[modalType ?? ''], [modalType]);

  return (
    <FjFlexContainer>
      <AlertUi store={store} />
      <LicenseConfirmationModal />
      <FjFlexContainer>
        <SuperAdminToolArea />
        {currentPage}
        {currentModal}
      </FjFlexContainer>
    </FjFlexContainer>
  );
};
